import Dialog from "@mui/material/Dialog"
import { MobileSubscription } from "../../interface/MobileSubscription"
import DialogTitle from "@mui/material/DialogTitle"
import DialogContent from "@mui/material/DialogContent"
import Button from "@mui/material/Button"
import DialogActions from "@mui/material/DialogActions"
import { useEffect, useState } from "react"
import { BillingApi } from "../../api/BillingApi"
import { MobileSubscriptionResponseStatus } from "../../interface/MobileSubscriptionResponseStatus"
import Card from "@mui/material/Card"
import CardHeader from "@mui/material/CardHeader"
import { LottieLoading } from "../../components/placeholder/LottieLoading"
import Typography from "@mui/material/Typography"
import moment from "moment"
import Grid from "@mui/material/Grid"
import Box from "@mui/material/Box"


// Icons
import CheckIcon from "@mui/icons-material/Check"
import CrossIcon from "@mui/icons-material/Close"
import ReceiptIcon from "@mui/icons-material/Receipt"
import CalendarMonth from "@mui/icons-material/CalendarMonth"
import CalendarYear from "@mui/icons-material/CalendarToday"
import DeleteIcon from "@mui/icons-material/Delete"
import RefreshIcon from "@mui/icons-material/Refresh"
import StatusIcon from "@mui/icons-material/Power"

import { ConfirmModal } from "../../components/modals/Confirm/ConfirmModal"
import CircularProgress from "@mui/material/CircularProgress"


interface SubscriptionManageModalAndroidProps
{
    open: boolean
    onClose: () => void
    subscriptionListItem: MobileSubscription
    onRefresh: () => void
}

export const SubscriptionManageModalAndroid = ({ open, onClose, subscriptionListItem, onRefresh }: SubscriptionManageModalAndroidProps) => {

    const [ subscriptionStatus, setSubscriptionStatus ] = useState<MobileSubscriptionResponseStatus | undefined>(undefined)
    const [ subscription, setSubscription ] = useState<MobileSubscription | undefined>(undefined)

    const [ loadingSubscription, setLoadingSubscription ] = useState(false)
    const [ deletingSubscription, setDeletingSubscription ] = useState(false)
    const [ showConfirmDelete, setShowConfirmDelete ] = useState(false)
    const [ syncing, setSyncing ] = useState(false)


    useEffect(() => {

        setSubscription(subscriptionListItem)

    }, [])


    useEffect(() => {

        getSubscriptionStatus(true)

    }, [subscription])

    const getSubscriptionStatus = async (progress: boolean) => {

        if(progress) setLoadingSubscription(true)
        try
        {
            if(!subscription?._id) return
            const response = await new BillingApi().getMobileSubscriptionStatusForUser(subscription._id)
            setSubscriptionStatus(response)
        }
        catch(error)
        {

        }

        if(progress) setLoadingSubscription(false)

    }


    const handleDelete = async () => {

        setDeletingSubscription(true)

        try
        {
            if(!subscription?._id) return
            const response = await new BillingApi().deleteMobileSubscription(subscription._id)
            if(response)
            {
                onRefresh()
                onClose()
            }
            
        }
        catch(error)
        {

        }

        setDeletingSubscription(false)
    }

    const handleSync = async () => {

        setSyncing(true)
        try
        {
            if(!subscription?._id) return
            const response = await new BillingApi().syncMobileSubscriptionStatusForUser(subscription._id)
            setSubscription(response)
        }
        catch(error)
        {

        }

        setSyncing(false)

    }


    return (<Dialog open={open} onClose={onClose} fullWidth maxWidth="lg">

        <DialogTitle>Manage Subscription for {subscription?.email}</DialogTitle>

        { loadingSubscription && <DialogContent>
            <LottieLoading 

                containerHeight="30vh" 
                text="Getting subscription details" 
                animation={require("../../animations/person-lottie.json")} 
                height={200} 
                width={200} 
                loop/></DialogContent>}

        { !loadingSubscription && <DialogContent>

            <Typography sx={{ ml: 1 }}>AlgoTrader Order Details</Typography>
            
            <Grid container>


                <Grid item xs={3}>
                     <Card style={styles.card}>
                        <CardHeader avatar={subscriptionStatus?.isActive ? <CheckIcon color="success" /> : <CrossIcon color="warning" />} title="Subscription State" subheader={subscriptionStatus?.isActive ? "Active" : "Not Active"} />
                    </Card>
                </Grid>

                <Grid item xs={3}>
                     <Card style={styles.card}>
                        <CardHeader avatar={<ReceiptIcon color="success" />} title="Last bill" subheader={moment(subscription?.lastBillDate).format("llll")} />
                    </Card>
                </Grid>

                  <Grid item xs={3}>
                     <Card style={styles.card}>
                        <CardHeader avatar={<ReceiptIcon color="info" />} title="Next bill" subheader={moment(subscription?.nextBillDate).format("llll")} />
                    </Card>
                </Grid>

                  <Grid item xs={3}>
                     <Card style={styles.card}>
                        <CardHeader avatar={<ReceiptIcon color="secondary" />} title="Last sync (last update)" subheader={moment(subscription?.lastUpdated).format("llll")} />
                    </Card>
                </Grid>
                
            </Grid>
           


            <Typography  sx={{ ml: 1 }}>Android Order Details</Typography>

            <Card style={styles.card}>
                <CardHeader avatar={<StatusIcon color="info" />} title="Subscription Status" subheader={subscriptionStatus?.response?.subscriptionState || "unknown"} />
            </Card>

           <Card style={styles.card}>
                <CardHeader avatar={<CheckIcon />} title="Acknowledgement State" subheader={subscriptionStatus?.response?.acknowledgementState || "unknown"} />
            </Card>

           <Typography  sx={{ ml: 1 }}>Subscription Details</Typography>

           { subscriptionStatus?.response?.lineItems.map((lineItem, key) => {
            return (
              <Card key={key} style={styles.card}>
                <CardHeader avatar={lineItem.productId === "algotrader_monthly" ? <CalendarMonth /> : <CalendarYear />} 
                    title={`Product ID: ${lineItem.productId}`} 
                    subheader={`Expiry time: ${moment(lineItem.expiryTime).format("llll")} (${moment(lineItem.expiryTime).fromNow()}) - Price: ${lineItem?.autoRenewingPlan?.recurringPrice.units} (${lineItem?.autoRenewingPlan?.recurringPrice.currencyCode})`} />
            </Card>
            )
           })}


        </DialogContent> }

        { !loadingSubscription && <DialogActions>
            <Button color="secondary" onClick={() => onClose()} startIcon={<CrossIcon /> }>Close</Button>
            <Box flex={1} />
            <Button color="error" startIcon={<DeleteIcon /> } onClick={() => setShowConfirmDelete(true)}>Delete Subscription</Button>
            <Button disabled={syncing} color="info" startIcon={syncing ? <CircularProgress size={16}/> : <RefreshIcon /> } onClick={handleSync}>Sync</Button>

        </DialogActions> }

        { showConfirmDelete && <ConfirmModal
             id={subscription?._id as string}
             handleClose={() => setShowConfirmDelete(false)} 
             onConfirm={handleDelete} 
             open 
             description="Are you sure you want to delete this users subscription?"
             title="Confirm delete subscrption"/>}
        
    </Dialog>)
}


const styles = { 
    card: {
        margin: 6
    }
}